"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ErrorType;
(function (ErrorType) {
    ErrorType["storeInitializationError"] = "STORE_INITIALIZATION_ERROR";
    ErrorType["duplicateNamespace"] = "DUPLOCATE_NAMSPACE";
    ErrorType["namespaceNotFound"] = "NAMESPACE_NOT_FOUND";
})(ErrorType = exports.ErrorType || (exports.ErrorType = {}));
//# sourceMappingURL=error-types.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/state-manager/errors/error-types.js
// module id = 1181
// module chunks = 8